<template>
  <div
    ref="$el"
    :style="`min-height: ${minHeight}px`"
  >
    <slot v-if="active" />
  </div>
</template>

<script setup lang="ts">
// https://medium.com/js-dojo/lazy-rendering-in-vue-to-improve-performance-dcccd445d5f
import { ref, nextTick, onMounted } from 'vue'

export interface Props {
  minHeight?: number
  rootMargin?: string
  renderOnIdle?: boolean
}

const props = defineProps<Props>()
const $el = ref<HTMLElement>()
const active = ref(false)

const onIdle = (cb = () => {}) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(cb)
  } else {
    setTimeout(() => nextTick(cb), 300)
  }
}

const observer = new IntersectionObserver(([{ isIntersecting }]) => {
  if (isIntersecting) {
    // console.log('[lazy-render] render on intersection', $el.value)
    active.value = true
    observer.disconnect()
  }
}, {
  rootMargin: props.rootMargin || '300px 0px 300px 0px'
})

if (props.renderOnIdle) {
  onIdle(() => {
    // console.log('[lazy-render] render on idle', $el.value)
    active.value = true
    observer.disconnect()
  })
}

onMounted(() => {
  if (!$el.value) {
    console.warn('[lazy-render] $el is undefined')
    return
  }
  observer.observe($el.value)
})
</script>
